import { apiRequest } from 'utils/request'

export const get = async () =>
  apiRequest({
    uri: '/harnesses',
  })
